import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ReplaceItemsCommand from './replaceItemsCommand';

/**
 * Set item accessory command
 *
 * @class SetItemAccessoryCommand
 * @extends AbstractCommand
 */
export default class SetItemAccessoryCommand extends ReplaceItemsCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        if (this.replacements.length > 1) {
            return `Set accessory of ${this.replacements.length} items`;
        }
        return 'Set accessory of item';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SetItemAccessoryCommand = SetItemAccessoryCommand;
